module.exports = __webpack_public_path__ + "static/gatsby-icon-d1479c26d1161fa57cc3e02f286f3671.png";